export const BACKGROUND_COLOR = 'rgb(230, 230, 250)'
export const CELL_SIZE = 20
const PADDING = CELL_SIZE * 0.1

const flatIndexWithGridSize = (rows, columns) => (row, col) => {
  if (row < 0 || col < 0 || col >= columns || row >= rows) return -1
  return col + row * columns
}

export const removeWalls = (cell, neighbor) => {
  const verticalDiff = cell.row - neighbor.row
  if (verticalDiff !== 0) {
    if (verticalDiff === 1) {
      cell.walls.top = false
      neighbor.walls.bottom = false
    } else if (verticalDiff === -1) {
      cell.walls.bottom = false
      neighbor.walls.top = false
    }
  }

  const horizontalDiff = cell.col - neighbor.col
  if (horizontalDiff !== 0) {
    if (horizontalDiff === 1) {
      cell.walls.left = false
      neighbor.walls.right = false
    } else if (horizontalDiff === -1) {
      cell.walls.right = false
      neighbor.walls.left = false
    }
  }
}

export class Cell {
  walls = {
    top: true,
    right: true,
    bottom: true,
    left: true,
    diagonalDown: false,
    diagonalUp: false,
  }

  visited = false
  current = false

  constructor(row, col) {
    this.row = row // j
    this.col = col // i
  }

  drawIfWall = (p5) => (strokeColor) => (wall, cb) => {
    if (wall) p5.stroke(strokeColor)
    cb()
    p5.stroke(BACKGROUND_COLOR)
  }

  fixCorners = (p5) => (strokeColor) => (x, y) => {
    p5.stroke(strokeColor)
    p5.line(x, y, x, y)
    p5.line(x + CELL_SIZE, y, x + CELL_SIZE, y)
    p5.line(x, y + CELL_SIZE, x, y + CELL_SIZE)
    p5.line(x + CELL_SIZE, y + CELL_SIZE, x + CELL_SIZE, y + CELL_SIZE)
    p5.stroke(BACKGROUND_COLOR)
  }

  show = ({ p5, backgroundColor, strokeColor = 'rgb(255, 127, 80)' } = {}) => {
    const x = this.col * CELL_SIZE
    const y = this.row * CELL_SIZE
    p5.stroke(BACKGROUND_COLOR)

    const drawColoredWall = this.drawIfWall(p5)(strokeColor)

    drawColoredWall(this.walls.top, () => p5.line(x, y, x + CELL_SIZE, y))
    drawColoredWall(this.walls.bottom, () =>
      p5.line(x + CELL_SIZE, y + CELL_SIZE, x, y + CELL_SIZE),
    )
    drawColoredWall(this.walls.left, () => p5.line(x, y + CELL_SIZE, x, y))
    drawColoredWall(this.walls.right, () =>
      p5.line(x + CELL_SIZE, y, x + CELL_SIZE, y + CELL_SIZE),
    )

    this.fixCorners(p5)(strokeColor)(x, y)

    if (backgroundColor) {
      p5.noStroke()
      p5.fill(backgroundColor)
      p5.rect(x, y, CELL_SIZE, CELL_SIZE)
    }

    if (this.current) {
      p5.stroke('purple')
      p5.fill('purple')
      p5.rect(
        x + PADDING,
        y + PADDING,
        CELL_SIZE - PADDING * 2,
        CELL_SIZE - PADDING * 2,
      )
    }
  }

  checkNeighbors = (p5) => (grid, rows, columns) => {
    const flatIndex = flatIndexWithGridSize(rows, columns)
    const neighbors = []

    const top = this.row > 0 ? grid[flatIndex(this.row - 1, this.col)] : null
    const right =
      this.col < columns ? grid[flatIndex(this.row, this.col + 1)] : null
    const bottom =
      this.row < rows ? grid[flatIndex(this.row + 1, this.col)] : null
    const left = this.col > 0 ? grid[flatIndex(this.row, this.col - 1)] : null

    if (top && !top.visited) neighbors.push(top)
    if (bottom && !bottom.visited) neighbors.push(bottom)
    if (left && !left.visited) neighbors.push(left)
    if (right && !right.visited) neighbors.push(right)

    if (neighbors.length === 0) return null

    const index = p5.floor(p5.random(0, neighbors.length))

    return neighbors[index]
  }
}
